import React, { useState, useEffect } from 'react'
import {v4 as uuidv4} from 'uuid';
import Todos from './Todos';

const getLocalStorage = () => {
    let todos = localStorage.getItem('todos')

    if(todos){
        return JSON.parse(localStorage.getItem("todos"))
    }else{
        return []
    }
}

function Input() {

    const [input, setInput] = useState("")
    const [todos, setTodos] = useState([])

    const handleSubmit = (e) => {
        e.preventDefault()

        const addTask = {
            id: uuidv4(),
            title: input
        }
        setTodos([addTask, ...todos])
        setInput("")
    }

    const deleteItems = (id) =>{
        setTodos(todos.filter((todo) => todo.id !==id))
    }

    useEffect(() => {
        localStorage.setItem("todos", JSON.stringify(todos))
    }, [todos])
    

  return (
    <div>
        <form className='flex item-center justify-center mt-20' onSubmit={handleSubmit}>
            <input 
                type='text'
                name='text' 
                placeholder='enter your todo!'
                className='py-2 px-5 rounded-lg bg-gray-700 text-white tracking-wide'
                autoComplete='off'
                value={input}
                onChange={(e) => setInput(e.target.value)}
            />
        </form>

        <Todos todos={todos} setTodos={setTodos} deleteItems={deleteItems}/>

    </div>
  )
}

export default Input